import React from "react";
import { useTranslation } from "react-i18next";
import { Lightbulb, Award, TrendingUp, BadgeCheck, Leaf, Globe2 } from "lucide-react";

const cardBase = {
  border: "1px solid #e6e6e6",
  borderRadius: 8,
  background: "#fbfbfb",
  padding: 24,
  minHeight: 220,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

const iconStyle = { width: 64, height: 64, borderRadius: "50%", border: "2px solid #c8102e", display: "flex", alignItems: "center", justifyContent: "center", background: "#fff" };

const ObjectivesSection = () => {
  const { t } = useTranslation();

  // Ensure each card gets a distinct icon (in order)
  // Use more distinct icons for the first two items
  const iconByIndex = [Lightbulb, Award, TrendingUp, BadgeCheck, Leaf, Globe2];

  const objectives = [
    t("EmiratesMade.Objectives.1", { defaultValue: "Promote high-quality products and services manufactured in the UAE." }),
    t("EmiratesMade.Objectives.2", { defaultValue: "Strengthen the national identity of 'Made in the Emirates.'" }),
    t("EmiratesMade.Objectives.3", { defaultValue: "Support Emirati manufacturers — especially SMEs — in improving quality and export readiness." }),
    t("EmiratesMade.Objectives.4", { defaultValue: "Enhance consumer trust in local brands." }),
    t("EmiratesMade.Objectives.5", { defaultValue: "Encourage innovation, sustainability, and industrial excellence." }),
    t("EmiratesMade.Objectives.6", { defaultValue: "Attract investments and international partnerships to the UAE’s industrial sector." }),
  ];

  return (
    <section id="objectives" style={{ padding: "60px 10%", backgroundColor: "#fff" }}>
      <style>{`
        .obj-grid { display:grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
        .obj-card { position:relative; border:1px solid #e6e6e6; border-radius:10px; background:#fbfbfb; padding:24px; min-height:220px; display:flex; flex-direction:column; align-items:center; justify-content:center; transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease, background .25s ease; }
        .obj-card:hover { transform: translateY(-6px); box-shadow: 0 12px 26px rgba(0,0,0,.12); border-color: var(--uae-green); background: #ffffff; }
        .obj-icon { width:70px; height:70px; border-radius:50%; display:flex; align-items:center; justify-content:center; border:2px solid #c8102e; background:#fff; transition: transform .25s ease, background .25s ease, border-color .25s ease; }
        .obj-card:hover .obj-icon { transform: scale(1.06); background: radial-gradient(circle at 50% 50%, #fff, #f7fbf9); border-color: var(--uae-green); }
        .obj-title { margin-top: 12px; color:#0a2750; font-weight:700; font-size:16px; text-align:center; }
        .obj-text { margin-top: 6px; color:#4b5563; text-align:center; line-height:1.7; }
        @media (max-width: 980px) { .obj-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 640px) { .obj-grid { grid-template-columns: 1fr; } }
      `}</style>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 26, fontWeight: 700, color: "#0a2750", margin: 0 }}> 
          {t("EmiratesMade.Objectives.title", { defaultValue: "Objectives" })}
        </h2>
        <div style={{ width: 64, height: 6, borderRadius: 3, background: "var(--uae-green)", marginTop: 8 }} />
      </div>
      <div className="obj-grid">
        {objectives.map((text, i) => {
          const Icon = iconByIndex[i % iconByIndex.length];
          return (
            <div key={i} className="obj-card">
              <div className="obj-icon">
                <Icon size={24} color="#c8102e"/>
              </div>
              <p className="obj-text">{text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ObjectivesSection;
